import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import { IconFault, IconWarningType } from '../../../../../Icons/MotionPortalIcons';
import './styles.scss';

const DcVoltageChartToolTipComponent = ({
    timeStamp,
    uom,
    mean,
    min,
    max,
    faultCount,
    warningCount,
    title,
}) => {
    return (
        <div className='custom-dc-voltage-chart-tooltip' id='dc-voltage-chart-tooltip'>
            <div className='t-header' id='dc-voltage-chart-tooltip-header'>
                {title || translate('ABB.Powertrain.Frontend.dcVoltageLabel')}
                <span className='t-date'>
                    {timeStamp ? formatDateTime(timeStamp) : '-'}
                </span>
            </div>
            <div className='t-item t-group' id='dc-voltage-chart-tooltip-values'>
                <div className='t-subitem'>
                    <span className='t-label'>{translate('ABB.Powertrain.Frontend.meanLabel')} :</span>
                    <span className='t-value'>{mean ?? '-'}{uom ? ` ${uom}` : ''}</span>
                </div>
                <div className='t-subitem'>
                    <span className='t-label'>{translate('ABB.Powertrain.Frontend.rangeLabel')} : </span>
                    <span className='t-value'>{min ?? '-'} / {max ?? '-'}</span>
                </div>
            </div>
            <div className='t-item' id='dc-voltage-chart-tooltip-faults'>
                <IconFault className='t-icon' />
                <span className='t-label'>{translate('ABB.Powertrain.Frontend.relatedFaultsLabel')} : </span>
                <span className='t-value'>{faultCount ?? 0}</span>
            </div>
            <div className='t-item'>
                <IconWarningType className='t-icon' />
                <span className='t-label'>{translate('ABB.Powertrain.Frontend.relatedWarningsLabel')} : </span>
                <span className='t-value'>{warningCount ?? 0}</span>
            </div>
        </div>
    );
};

DcVoltageChartToolTipComponent.propTypes = {
    timeStamp: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date)
    ]),
    value: PropTypes.shape({
        color: PropTypes.string,
        label: PropTypes.string,
    }),
    isUTC: PropTypes.bool,
    mean: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    faultCount: PropTypes.number,
    warningCount: PropTypes.number,
    faultLabel: PropTypes.string,
    warningLabel: PropTypes.string,
    title: PropTypes.string
};

export default DcVoltageChartToolTipComponent;
